/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CnyWalletBillListVo } from './CnyWalletBillListVo';
import {
    CnyWalletBillListVoFromJSON,
    CnyWalletBillListVoFromJSONTyped,
    CnyWalletBillListVoToJSON,
    CnyWalletBillListVoToJSONTyped,
} from './CnyWalletBillListVo';

/**
 * 
 * @export
 * @interface ResponseCnyWalletBillListVo
 */
export interface ResponseCnyWalletBillListVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseCnyWalletBillListVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseCnyWalletBillListVo
     */
    message?: string;
    /**
     * 
     * @type {CnyWalletBillListVo}
     * @memberof ResponseCnyWalletBillListVo
     */
    data?: CnyWalletBillListVo;
}

/**
 * Check if a given object implements the ResponseCnyWalletBillListVo interface.
 */
export function instanceOfResponseCnyWalletBillListVo(value: object): value is ResponseCnyWalletBillListVo {
    return true;
}

export function ResponseCnyWalletBillListVoFromJSON(json: any): ResponseCnyWalletBillListVo {
    return ResponseCnyWalletBillListVoFromJSONTyped(json, false);
}

export function ResponseCnyWalletBillListVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseCnyWalletBillListVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : CnyWalletBillListVoFromJSON(json['data']),
    };
}

export function ResponseCnyWalletBillListVoToJSON(json: any): ResponseCnyWalletBillListVo {
    return ResponseCnyWalletBillListVoToJSONTyped(json, false);
}

export function ResponseCnyWalletBillListVoToJSONTyped(value?: ResponseCnyWalletBillListVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': CnyWalletBillListVoToJSON(value['data']),
    };
}

